"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4665],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 44665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51469);
/* harmony import */ var _data_sections_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28117);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BeforeNltSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(5675), __webpack_require__.e(296)]).then(__webpack_require__.bind(__webpack_require__, 70296)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(70296)]
  }
});
const BeforeNltSectionMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3382), __webpack_require__.e(5675), __webpack_require__.e(9463)]).then(__webpack_require__.bind(__webpack_require__, 19463)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(19463)]
  }
});
const data = _data_sections_json__WEBPACK_IMPORTED_MODULE_3__/* .beforeNlt */ .ox;

const BeforeNltSectionContainer = () => {
  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .useBreakpointValue */ .Sx)({
    base: true,
    lg: false
  });
  return isMobile ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BeforeNltSectionMobile, {
    image: data.image,
    imageAlt: data.imageAlt,
    title: data.title,
    items: data.items,
    actionTitle: data.actionTitle,
    footer: data.footer
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BeforeNltSection, {
    image: data.image,
    imageAlt: data.imageAlt,
    title: data.title,
    items: data.items,
    actionTitle: data.actionTitle,
    footer: data.footer
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BeforeNltSectionContainer);

/***/ }),

/***/ 28117:
/***/ (function(module) {

module.exports = JSON.parse('{"uZ":{"image":"https://static1.carplanner.com/website/assets/services.jpg","imageAlt":"Una famiglia affacciata dai finestrini della propria auto al tramonto","itemsTitle":"Tutti i servizi inclusi\\nnel Noleggio a Lungo Termine","items":["Assicurazione RCA e Kasko","Incendio, furto e danni","Manutenzione ordinaria e straordinaria","Immatricolazione e messa su strada","Soccorso e assistenza stradale H24","Servizi clienti dedicato"],"actionText":"SCOPRI DI PIÙ","actionTitle":"Scopri tutti i vantaggi del Noleggio a Lungo Termine","descriptionTitle":"Preferisci l’Acquisto oppure il Noleggio Auto a Lungo Termine?","description":"La scelta non è facile: sono tantissimi gli aspetti da tenere in considerazione\\nprima di acquistare un auto o optare per il Noleggio a Lungo Termine."},"Mv":{"image":"https://static1.carplanner.com/website/assets/more-info.jpg","imageAlt":"Quattro ragazzi sorridenti a bordo di un\'auto, inquadrati dal parabrezza","itemsTitle":"Confronta le Offerte e scegli la soluzione migliore per te!","items":["Minimo investimento finanziario","Nessun costo di gestione o manutenzione","Canone mensile fisso","Risparmia tempo nella gestione della tua auto","Nessun rischio di svalutazione dell’auto","Nessuna responsabilità in caso di furto/incendio","Auto sempre nuova"],"actionText":"Consulta le nostre FAQ","actionTitle":"Consulta le nostre FAQ sul Noleggio a Lungo Termine","descriptionTitle":"Vuoi maggiori informazioni su questo servizio?","description":"Su CarPlanner trovi le auto delle migliori marche disponibili con \\"Offerte Shock\\" che ti permetteranno di avere l’auto che hai sempre sognato ad un canone mensile ancora più conveniente, anche in \\"Consegna Veloce\\"."},"cM":{"image":"https://static1.carplanner.com/website/assets/how-nlt-works.png","imageAlt":"Un uomo al posto di guida riceve le chiavi dell\'auto dal finestrino","itemsTitle":"I vantaggi del Noleggio a Lungo Termine","items":["Minimo investimento finanziario","Nessun costo di gestione o manutenzione","Canone mensile fisso","Risparmia tempo nella gestione della tua auto","Nessun rischio di svalutazione dell’auto","Nessuna responsabilità in caso di furto/incendio","Auto sempre nuova"],"descriptionTitle":"Come funziona\\nil Noleggio a Lungo Termine con CarPlanner?","description":"Grazie alla collaborazione con le migliori società di Noleggio, ti garantiamo sempre le offerte più vantaggiose del mercato. Dovrai solo scegliere l\'auto che preferisci tra centinaia di offerte disponibili!","href":"/come-funziona-noleggio-a-lungo-termine","hrefTitle":"Scopri tutti i vantaggi"},"ox":{"image":"https://static1.carplanner.com/website/assets/before-nlt.png","imageAlt":"Una Fiat 500L gialla e una Peugeot 2008 azzurra affiancate su sfondo bianco","title":"Cosa fare per Noleggiare un’auto a lungo termine con CarPlanner","items":[{"icon":"https://static1.carplanner.com/website/assets/icons-bg-circle.svg","title":"Scegli la tua Auto","description":"Approfondisci tutti i dettagli tecnici dell’auto, leggendo con attenzione la scheda."},{"icon":"https://static1.carplanner.com/website/assets/icons-bg-circle.svg","title":"Personalizza offerta","description":"La nostre offerte sono personalizzabili*, puoi decidere se versare l’anticipo o meno, scegliere la durata e il chilometraggio che preferisci."},{"icon":"https://static1.carplanner.com/website/assets/icons-bg-circle.svg","title":"Compila la richiesta","description":"Compila il form con i tuoi dati per richiedere un preventivo gratuito e bloccare il prezzo dell\'auto che hai scelto."},{"icon":"https://static1.carplanner.com/website/assets/icons-bg-docs.svg","title":"Ordina la tua Auto","description":"Carica online i documenti necessari e affidati ai nostri consulenti esperti per sottoscrivere il tuo Noleggio e ricevere l\'auto nella tua città."}],"href":"/noleggio-a-lungo-termine","action":"Scopri tutti i vantaggi","actionTitle":"Scopri le offerte di Noleggio a Lungo Termine","footer":"*In base all’opzione che scegli, il canone mensile può cambiare. Le offerte sono soggette ad esaurimento."}}');

/***/ })

}]);